import { render } from "./letter-forward-step4.vue?vue&type=template&id=3458b435"
import script from "./letter-forward-step4.vue?vue&type=script&lang=js"
export * from "./letter-forward-step4.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__